import 'custom-event-polyfill';
import '@babel/polyfill';
// import '@fortawesome/fontawesome-free/js/all.js';
// My own polyfill
// https://stackoverflow.com/questions/4313841/insert-a-string-at-a-specific-index
if (!String.prototype.splice) {
	/**
		* {JSDoc}
		*
		* The splice() method changes the content of a string by removing a range of
		* characters and/or adding new characters.
		*
		* @this {String}
		* @param {number} start Index at which to start changing the string.
		* @param {number} delCount An integer indicating the number of old chars to remove.
		* @param {string} newSubStr The String that is spliced in.
		* @return {string} A new string with the spliced substring.
		*/
	String.prototype.splice = function(start, delCount, newSubStr) {
		return this.slice(0, start) + newSubStr + this.slice(start + Math.abs(delCount));
	};
}

// Object.values

var objectToValuesPolyfill = function(object) {
    return Object
             .keys(object)
             .map(
                  function(key) {
                    return object[key];
                  }
              );
}

Object.values = Object.values || objectToValuesPolyfill;

// Object.entries

var objectToEntriesPolyfill = function(object) {
    return Object
             .keys(object)
             .map(
                  function(key) {
                    return [key, object[key]];
                  }
              );
}

Object.entries = Object.entries || objectToEntriesPolyfill;

require('./bootstrap');

import Vue from "vue";

import axios from "axios";
import store from "./store";
import vueDebounce from 'vue-debounce'
Vue.use(vueDebounce)

Vue.component('pagination', require('laravel-vue-pagination'))

import moment from "vue-moment";
Vue.use(moment);

import _ from "lodash";

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
Vue.use(PerfectScrollbar)

import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
Vue.component("DateRangePicker", DateRangePicker);

import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'
Vue.use(Autocomplete)


import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)

import './fonts/feather-icomoon/style.css'


import PlusButton from './components/common/PlusButton'
Vue.component("PlusButton", PlusButton);



Vue.config.productionTip = false

import Multiselect from "vue-multiselect";
Vue.component("Multiselect", Multiselect);

Vue.prototype.moment = moment

Vue.filter('striphtml', function (value) {
  var div = document.createElement("div");
  div.innerHTML = value;
  var text = div.textContent || div.innerText || "";
  return text;
});
Vue.filter('textInitials', value => {
    if(!value) return ''
    var initials = value.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);
    if (initials == null) {
      return "N/A";
    }
    return (initials.length > 2) ? initials[0].toUpperCase()+initials[1].toUpperCase() : (initials.join('')).toUpperCase()
})

import { ValidationProvider,ValidationObserver, extend } from 'vee-validate';
import { required, email, confirmed } from 'vee-validate/dist/rules';
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);


extend('required', {
  ...required,
  message: 'This field is required'
});
extend("email", {
  ...email,
  message: "Valid email address is required",
});
extend("confirmed", {
  ...confirmed,
  message: "Password did not match",
});


import vClickOutside from 'v-click-outside'
Vue.use(vClickOutside)

import {sortTasks} from './mixin'
import {getPlural} from './mixin'
import {getPostPlural} from './mixin'
Vue.mixin({
    methods: {
        tryJSONParse: (input) => {
          try {
            return JSON.parse(input)
          } catch (e) {
            return input
          }
        },
        sortTasks: (payload) => {
          sortTasks(payload)
        },
        getPlural: (count, single, plural) => {
          return getPlural(count, single, plural);
        },
        getPostPlural: (count) => {
          return getPostPlural(count);
        },
        clickedOutsideFilter: function () {
            this.$root.$emit('bv::hide::popover')
        },
        fromNowDate: function (date) {
          return this.$moment(date).fromNow();
        },
        isSafari: function() {
          return !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/);
        },
        isMobile: function() {
          var check = false;
          (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
          return check;
        },
        getFieldJson(fieldArray, fieldKey) {
          let field
          field = _.filter(fieldArray, {field_key: fieldKey})
          if(field) {
            return field[0]
          }
        },
        getProjectColor(project) {
          let projectColorField = this.getFieldJson(project.customFields, 'color_picker')
          if(projectColorField && projectColorField.value) {
            return projectColorField.value
          }
          return getComputedStyle(document.documentElement).getPropertyValue('--primary') || '#4C9850';
        },
    }
})
Vue.config.ignoredElements = ['krwidget'];

import CKEditor from 'ckeditor4-vue';
Vue.use(CKEditor);
// import Vue2Editor from "vue2-editor";
// Vue.use(Vue2Editor);



// import wysiwyg from "vue-wysiwyg";
// Vue.use(wysiwyg, {
//     hideModules: {
//         // justifyLeft: true,
//         // justifyCenter: true,
//         // justifyRight: true,
//         // table: true,
//         // separator: true,
//         code: true,
//         image: true
//     }
// });
// import "vue-wysiwyg/dist/vueWysiwyg.css";

import Router from "@/csmworkflow/js/routes.js";
import CsmApp from "@/csmworkflow/js/views/App";

// getting JWT token from localstorage
const jwtToken = store.getters.authToken;
if (jwtToken) {
    axios.defaults.headers.common["Authorization"] = "Bearer " + jwtToken;
} else {
    delete axios.defaults.headers.common["Authorization"]; // removing previously set token if it is not present in the localstorage
}

Vue.directive('click-outside', {
    bind: function(el, binding, vNode) {
      // Provided expression must evaluate to a function.
      if (typeof binding.value !== "function") {
        const compName = vNode.context.name;
        let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
        if (compName) {
          warn += `Found in component '${compName}'`;
        }
      }
      // Define Handler and cache it on the element
      const bubble = binding.modifiers.bubble;
      const handler = e => {
        let excludedClasses = ["exclude-outside-click", "prev", "tagged-tags", "tagged-contacts", "autocomplete-input", "logged-in-user"]
        if (excludedClasses.some(excludedClass => e.target.classList.contains(excludedClass))) return;
        if (bubble || (!el.contains(e.target) && el !== e.target)) {
          binding.value(e);
        }
      };
      el.__vueClickOutside__ = handler;
      // add Event Listeners
      document.addEventListener("pointerdown", handler);
    },
    unbind: function(el, binding) {
      // Remove Event Listeners
      document.removeEventListener("pointerdown", el.__vueClickOutside__);
      el.__vueClickOutside__ = null;
    }
  })

Vue.directive('field-dismiss', {
  bind: function(el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== "function") {
      const compName = vNode.context.name;
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`;
      if (compName) {
        warn += `Found in component '${compName}'`;
      }
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble;
    const handler = e => {
      let excludedClasses = ["exclude-outside-click", "prev", "tagged-tags", "tagged-contacts", "autocomplete-input", "logged-in-user"]
      if (excludedClasses.some(excludedClass => e.target.classList.contains(excludedClass))) {
        let parentFieldWrap = el.parentNode;
        if (parentFieldWrap != undefined) {
	        if (parentFieldWrap.classList != undefined) {
		        while(parentFieldWrap.classList.contains("field-wrap") != undefined) {
		        	if (parentFieldWrap.classList.contains("field-wrap") == false) {
		        			break;
		        	}
		          parentFieldWrap = parentFieldWrap.parentNode;
		          if (!parentFieldWrap) throw "Cannot find field-wrap element.";
		        }
		      }
        	if (parentFieldWrap.contains(e.target)) return;
      	}

      	return;
      }
      
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e);
      }
    };
    el.__vueClickOutside__ = handler;
    // add Event Listeners
    document.addEventListener("click", handler);
  },
  unbind: function(el, binding) {
    // Remove Event Listeners
    document.removeEventListener("click", el.__vueClickOutside__);
    el.__vueClickOutside__ = null;
  }
})


import VueTrumbowyg from './components/vue-trumbowyg/src';
import './components/vue-trumbowyg/dist/trumbowyg/dist/ui/trumbowyg.css';
// Plugins are optional
import './components/vue-trumbowyg/dist/trumbowyg/plugins/colors/trumbowyg.colors'
import './components/vue-trumbowyg/dist/trumbowyg/plugins/colors/ui/sass/trumbowyg.colors.scss'

Vue.use(VueTrumbowyg);


const csmApp = new Vue({
    el: "#csm-workflow",
    render: h => h(CsmApp),
    router: Router,
    store,
    moment,
    DateRangePicker,
    ValidationProvider,
    // created() {
    //     this.$store.dispatch('bindNamespaces', this.$store);
    // },
});


import Vue2TouchEvents from 'vue2-touch-events'
Vue.use(Vue2TouchEvents, {
  disableClick: true,
  swipeTolerance: 150
});



require('./jquery.tabbable');
$(document).on('keydown', '.multiselect', function(event) {
  if (event.which === 9) {
      if (event.shiftKey) {
        jQuery.tabPrev();
      } else {
        jQuery.tabNext();
      }
      var e = $.Event('click'); $(event.target).parent().siblings().find('.multiselect__option--highlight:not(.multiselect__option--selected)').trigger(e);
     event.preventDefault();
  }

  });
  
if(process.env.MIX_APP_DEBUG == 'false') {
  console.log = () => {}
}

export default csmApp;
